export default __webpack_public_path__ + "static/media/IconDesc_DronePort.256.84f795e7.png";